<template>
  <!-- -->
  <div class="laborer" style="height: 100%">
    <list-page>
      <list-table background-color="#FFF">
        <form-items :columns="3" :data="dataDetail">
          <form-item label="姓名">
            <el-input v-model="dataDetail.contractName" placeholder="请输入劳务人员姓名"/>
          </form-item>
          <form-item label="性别">
            <el-select v-model="dataDetail.contractSex" placeholder="请选择性别">
              <el-option value="1" label="男"/>
              <el-option value="2" label="女"/>
            </el-select>
          </form-item>
          <form-item label="手机号">
            <el-input v-model="dataDetail.phone" placeholder="请输入手机号"/>
          </form-item>
          <form-item label="人脸识别编号">
            <el-input v-model="dataDetail.contractPhone" placeholder="请输入人脸识别编号" :disabled="true"/>
          </form-item>
          <form-item label="工种">
            <c-custom-select value="dictCode" label="dictName"
                             :data-list="jobCategoryList" v-model="dataDetail.jobCategory"/>
          </form-item>
          <form-item label="身份证号">
            <el-input v-model="dataDetail.cardNo" placeholder="请输入身份证号码"/>
          </form-item>
          <form-item label="年龄">
            <el-input v-model="dataDetail.contractAge" placeholder="请输入年龄"/>
          </form-item>
          <form-item label="进场时间">
            <el-date-picker v-model="dataDetail.siteTimeIn" type="date" placeholder="选择日期" style="width: 100%"/>
          </form-item>
          <form-item label="退场时间">
            <el-date-picker v-model="dataDetail.siteTimeOut" type="date" placeholder="选择日期" style="width: 100%"/>
          </form-item>
          <form-item label="施工班组">
            <c-custom-select value="id" label="classmateName" @change="changeClassmate"
                             :data-list="classmateList" v-model="dataDetail.classmateId"/>
          </form-item>
          <form-item label="所属工地">
            <c-custom-select value="id" label="siteName" @change="changeSite"
                             :data-list="siteList" v-model="dataDetail.siteId" :read-only="true"/>
          </form-item>
          <form-item label="所属项目">
            <c-custom-select value="id" label="projectName" :data-list="projectList" v-model="dataDetail.projectId"
                             :read-only="true"/>
          </form-item>
          <form-item label="住址" :show-block="true">
            <el-input v-model="dataDetail.address" placeholder="请输入住址信息"/>
          </form-item>
          <form-item label="人脸识别">已认证</form-item>
          <form-item :show-block="true" label="身份认证">
            <image-upload v-model="dataDetail.identity"/>
          </form-item>
          <form-item  label="技能认证" :show-block="true">
            <image-upload v-model="dataDetail.skills"/>
          </form-item>
        </form-items>
      </list-table>
      <form-page :show-page="false">
        <page-button type="write" el-type="primary" @click="save">保存</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import ImageUpload from "@/components/h5/image/ImageUpload.vue";
import CCustomSelect from "@/views/h5/luqiao/display/c-custom-select.vue";
import commonLqApi from "@/api/dz-luqiao/luqiaoCommonApi";
import contractWorkersApi from "@/api/dz-luqiao/contractWorkersApi";
import commonApi from "@/api/commonApi";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "LaborersDetaill",
  components: {
    CCustomSelect,
    PageButton, ListPage, ListTable, FormPage, FormItems, FormItem, ImageUpload
  },
  data() {
    return {
      dataDetail: {
        contractName: '',     // 劳务人员名称
        phone: '',    // 劳务人员联系方式
        contractSex: '',      // 劳务人员性别
        jobCategory: '',      // 工种类别
        cardNo: '',           // 身份证编号
        contractAge: '',      // 劳务人员年龄
        classmateId: '',      // 班组id
        siteId: '',           // 工地id
        projectId: '',        // 项目id
        address: '',          // 地址
        checkFace: '',        // 是否人脸识别
        identity: '',         // 身份认证
        skills: '',           // 技能认证
      },
      siteList: [],
      projectList: [],
      classmateList: [],
      jobCategoryList: []
    };
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  async created() {
    this.init();
    // 查询工地
    this.projectList = await commonLqApi.queryProjectNoPage()
    // 查询项目
    this.siteList = await commonLqApi.querySiteNoPage()
    // 施工班组
    this.classmateList = await commonLqApi.queryClassmateNoPage()
    // 工种列表
    const user = await Util.getUserInfo()
    this.jobCategoryList = await commonApi.queryDictionaryList("JOB_CATEGORY", user.merchantId)
    // 是否编辑
    if (this.route.query.id) {
      await this.findById(this.route.query.id)
    }
  },
  methods: {
    init() {

    },
    async save() {
      this.dataDetail = await contractWorkersApi.saveSubmit(this.dataDetail)
    },
    changeClassmate(data) {
      this.dataDetail.siteId = data.siteId
    },
    changeSite(data) {
      this.dataDetail.projectId = data.projectId
    },
    async findById(id) {
      this.dataDetail = await contractWorkersApi.findById(id);
      let test = {"video":"20251031113447806111/video/video_8ad61ab2895bd4cf9b42282f8cde64b6.mp4","cover":"20251031113447806111/video/video_20251203174707759121.jpg"};
      this.dataDetail.video = JSON.stringify(test);
    }
  }
};
</script>

<style lang="scss" scoped>
.laborer {
  .list-table {
    padding: 10px;
  }
}
</style>
